import { Outlet, Navigate, useNavigate } from 'react-router-dom';
import Sidebar from '../../concepts/giantsys-tracking/components/organisms/Sidebar';
import { useEffect, useState } from 'react';
import { useAuth } from '../../apis/auth/AuthProvider';
import LogoutButton from '../../concepts/giantsys-tracking/components/molecules/LogoutButton';

const PrivateRoute = ({ sidebarItemList, handleVerifyLogin, routesReportPending }) => {
    const auth = useAuth();
    const navigate = useNavigate();
    const [isLogged, setIsLogged] = useState(false);
    const [isVerifying, setIsVerifying] = useState(true);

    const handleErrorVerifyLogin = () => {
        return navigate('/login');
    };

    const verifyLogin = async () => {
        let result = await auth.verifyLogin(handleVerifyLogin, handleErrorVerifyLogin);
        setIsVerifying(false);
        setIsLogged(result);
        if(result === true){
            console.log(auth.user);
        }
    };

    useEffect(() => {
        verifyLogin();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    if (isVerifying)
        return <></>;

    if (!isLogged)
        return <Navigate to="/login" />;
    return (
        <>
            <Sidebar accessList={sidebarItemList} adittionalRoutes={<LogoutButton />} routesReportPending={routesReportPending}/>
            <Outlet />
        </>
    );
};

export default PrivateRoute;
